export const initialValuesUserCreate = {
  email: "",
  password: "",
  re_password: "",
};
